export default __webpack_public_path__ + "static/media/Eternally Lit Lamp.b8d45247.png";